'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var reactUtils = require('@chakra-ui/react-utils');
var reactStately = require('react-stately');
require('@internationalized/date');
var reactAria = require('react-aria');
var useFormControlBridge = require('../utils/useFormControlBridge.js');
var useNormalizedProps = require('../utils/useNormalizedProps.js');
var useFieldPropsWithEvents = require('../utils/useFieldPropsWithEvents.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _excluded = ["stateBridge", "ariaBridge", "htmlProps"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * useTimeField
 *
 * Provides logic to render a time field.
 *
 * @param props - Props for the time field.
 * @param ref - Ref to the time field.
 * @returns An object containing the time field's state and props.
 */
function useTimeField(props, ref) {
  /** Renames certain props to fit the native HTML spec. */
  var renamedProps = useNormalizedProps.useNormalizedTimeFieldProps(props);

  /*
   *  Handles merging `useFormControl` + `useAriaTimeField` and `useTimeFieldState` as well as the user-provided
   *  props. This is necessary because `useAriaTimeField` and `useTimeFieldState` are using slightly different props
   *  or values for the same function.
   */
  var _useFormControlBridge = useFormControlBridge.useFormControlBridge(renamedProps),
    stateBridge = _useFormControlBridge.stateBridge,
    ariaBridge = _useFormControlBridge.ariaBridge,
    htmlProps = _useFormControlBridge.htmlProps,
    rest = _objectWithoutProperties__default["default"](_useFormControlBridge, _excluded);
  var _useLocale = reactAria.useLocale(),
    locale = _useLocale.locale;
  var state = reactStately.useTimeFieldState(_objectSpread({
    locale: locale
  }, stateBridge));
  var _useAriaTimeField = reactAria.useTimeField(ariaBridge, state, ref),
    fieldProps = _useAriaTimeField.fieldProps;

  // `fieldProps` with user-provided and form-control-given events.
  var fieldPropsWithEvents = useFieldPropsWithEvents.useFieldPropsWithEvents(fieldProps, state, rest);
  var getHtmlProps = React.useCallback(function () {
    var givenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, fieldPropsWithEvents), htmlProps), givenProps), {}, {
      ref: reactUtils.mergeRefs(ref, _ref)
    });
  }, [fieldPropsWithEvents, htmlProps, ref]);
  return {
    getHtmlProps: getHtmlProps,
    context: {
      state: state
    }
  };
}
exports.useTimeField = useTimeField;